import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'short-date',
  templateUrl: './short-date.component.html',
  styleUrl: './short-date.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShortDateComponent extends FieldType<FieldTypeConfig> implements OnInit {
  destroyRef = inject(DestroyRef);

  innerModel = new FormControl('');

  ngOnInit() {
    if (this.formControl.value) {
      const [year, month, day] = (this.formControl.value as string).split('-');

      this.innerModel.setValue(`${month}/${day}/${year}`);
    }

    this.innerModel.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      const month = (value as string).slice(0, 2);
      const day = (value as string).slice(2, 4);
      const year = (value as string).slice(4, 8);

      this.formControl.setValue(`${year}-${month}-${day}`);
    });
  }
}
